import React from "react";
import ReactApexChart from "react-apexcharts";
import { formatCurrency } from "utility/index";

class ApexChart extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      series: [
        {
          name: props.title || "",
          data: props.data || []
        }
      ],
      options: {
        chart: {
          type: 'bar',
          height: 350,
          toolbar: {
            show: false 
          },
          zoom: {
            enabled: false
          }
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '25%',
            endingShape: 'rounded'
          }
        },
        colors: ["#946A0E"],
        dataLabels: {
          enabled: false
        },
        tooltip: {
          enabled: true,
          y: {
            formatter: (value) => `${props?.selectedCountry} ${formatCurrency(value,props?.selectedCountry).toLocaleString()}`
          }
        },
        xaxis: {
          categories: ["Local Planned", "National Planned", "Project Planned"],
          tickPlacement: 'on',
          axisBorder: {
            show: true,
            color: '#000',
          },
          axisTicks: {
            show: true,
            color: '#000',
            height: 7,
          },
        },
        yaxis: {
          min: 0,
          max: Math.max(...props.data),
          tickAmount: 4,
          axisBorder: {
            show: true,
            color: '#000',
            width: 1,
          },
          axisTicks: {
            show: true,
            color: '#000',
            width: 7,
          },
        },
        grid: {
          show: false,
        },
        responsive: [
          {
            breakpoint: 1400,
            options: {
              chart: {
                height: "250",
              },
            },
          },
          {
            breakpoint: 1200,
            options: {
              chart: {
                height: "200",
              },
            },
          },
          {
            breakpoint: 480,
            options: {
              chart: {
                height: "300",
              },
            },
          },
        ]
      },
    };
  }

  componentDidUpdate(prevProps) {
    // Check if props.data has changed
    if (prevProps.data !== this.props.data) {
      const newMax = Math.max(...this.props.data, 10); // Calculate new max for y-axis
      this.setState({
        series: [
          {
            name: "Planned Budget Allocation",
            data: this.props.data
          }
        ],
        options: {

          tooltip: {
            ...this.state.options.tooltip,
            y: {
              formatter: (value) => `${this.props?.selectedCountry} ${formatCurrency(value,this.props?.selectedCountry).toLocaleString()}`
            }
          },
          yaxis: {
            ...this.state.options.yaxis,
            max: newMax // Update max value dynamically
          }
        }
      });
    }
  }

  render() {
    return (
      <div>
        <div id="chart">
          <ReactApexChart options={{...this.state.options,xaxis:{...{categories:this.props.categories,
        tickPlacement:"between",
          axisBorder: {
            show: true,
            color: '#000',
          },
          axisTicks: {
            show: true,
            color: '#000',
            height: 7,
          }}}}} cate series={this.state.series} type="bar" height={350} />
        </div>
      </div>
    );
  }
}

export default ApexChart;